.result-section + .result-section {
    margin-top: 8px;
}

.result-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 6px;
    margin: 0 4px;
    text-decoration: none;
    color: inherit;
    min-height: 36px;
}

.result-row:hover,
.result-row:focus,
.result-row:focus-visible {
    background-color: var(--list-hovered);
    outline: none;
}

.result-row--active {
    composes: result-row;
    background-color: var(--list-hovered);
}

.result-row-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    flex-shrink: 0;
}

.result-row-icon--navigation {
    composes: result-row-icon;
    background-color: var(--blue-lt);
}

.result-row-icon--action {
    composes: result-row-icon;
    background-color: var(--green-lt);
}

.result-row-icon--ai {
    composes: result-row-icon;
    background-color: var(--ai-purple-pink-xlt);
}

.result-row-badge {
    font-size: 11px;
    font-weight: 500;
    color: var(--grey);
    padding: 2px 6px;
    border-radius: 4px;
    background-color: var(--off-white);
    white-space: nowrap;
    flex-shrink: 0;
}

.result-row-badge--ai {
    composes: result-row-badge;
    background-color: var(--ai-purple-pink-xlt);
    color: var(--ai-purple-primary);
}
